import { FC } from 'react';

import {
  Select,
  SelectProps,
  Option,
} from '@beeline/design-system-react/extracted-styles';

export type TimezoneSelectProps = Omit<
  SelectProps<Option<string>>,
  | 'label'
  | 'size'
  | 'fullWidth'
  | 'placeholder'
  | 'noOptionsText'
  | 'options'
  | 'loading'
  | 'renderValue'
  | 'multiple'
>;
const renderValue = (options: Option<string>[]): string =>
  options[0]?.value ?? '';

export const timezones = new Map<number, Option<string>>();

const west = 2;
const east = 12;
for (let offset = west; offset <= east; offset++) {
  const option: Option<string> = {
    value: `UTC+${offset}`,
    id: offset,
  };
  timezones.set(offset, option);
}

const options: Option<string>[] = [...timezones.values()];

export const defaultTimezone = 3;

export const defaultTimezoneOption = timezones.get(defaultTimezone);

export const TimezoneSelect: FC<TimezoneSelectProps> = props => {
  return (
    <Select
      {...props}
      size='medium'
      label='Часовой пояс'
      fullWidth
      placeholder='выберите часовой пояс'
      noOptionsText='нет данных'
      options={options}
      renderValue={renderValue}
      multiple={false}
    />
  );
};
